import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import React, { Component } from 'react';
import { Menu } from '@headlessui/react';
import 'react-activity/lib/Spinner/Spinner.css';
import NotificationPopUp from './NotificationPopup';
import { logout, logOutUser } from '../../action/UserAction';
import { showNotification } from '../../action/NotificationAction';
import { getSystemFeature, notificationCount } from '../../action/AdminAction';
import store from '../../../sessionStorage';
import { RESPONSE_CONSTANT } from '../../../utils/ResponseConstant';

/**
 * @package VirtuOwl
 * @type {React.ComponentClass}
 */
class SuperAdminHeader extends Component {
    static propTypes = {
        getSystemFeature: PropTypes.func,
    };
    constructor(props) {
        super(props);
        this.state = {
            isLogout: false,
            anchorEl: null,
            bellNotification: null,
            notificationCount: 0,
            notOpen: false,
        };
    }

    /**
     * @inheritDoc
     */
    componentDidMount() {
        document.title = `${this.props.levelTitle} || ${this.props.title}`;
        this.getnotificationCount();
    }

    /**
     * handle login button disable
     */
    disableLogin() {
        this.setState({ isLogout: !this.state.isLogout });
    }

    /**
     * Sign out user from application
     */
    inkoveSignOut() {
        this.disableLogin();
        this.props.logOutUser((respose) => {
            this.disableLogin();
            if (respose) {
                if (respose.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                    logout(() => {
                        window.location.href = `/`;
                    });
                } else {
                    this.props.showNotification(respose.response_message, 'error');
                    return;
                }
            } else {
                this.props.showNotification(
                    'Something went wrong, Please try again later',
                    'error'
                );
                return;
            }
        });
    }

    // getDetails
    getDetails() {
        this.props.getSystemFeature((respose) => {
            if (respose) {
                if (respose.code !== RESPONSE_CONSTANT.SUCCESS_CODE) {
                    this.props.showNotification(respose.response_message, RESPONSE_CONSTANT.ERROR);
                    return;
                }
            } else {
                this.props.showNotification(
                    RESPONSE_CONSTANT.SOMETHING_WENT_WRONG,
                    RESPONSE_CONSTANT.ERROR
                );
                return;
            }
        });
    }

    // handleClick
    handleClick = (event) => {
        this.setState({ anchorEl: event.currentTarget });
    };

    // handleNotificationClick
    handleNotificationClick = (event) => {
        this.setState({
            bellNotification: event.currentTarget,
            notOpen: !this.state.notOpen,
        });
    };

    //handleClose
    handleClose = () => {
        this.setState({ anchorEl: null });
    };

    //handleCloseNotification
    handleCloseNotification = () => {
        this.setState({ bellNotification: null });
    };

    //opened
    opened = (value) => {
        this.setState({ notificationOpened: value });
    };

    // getnotificationCount
    getnotificationCount() {
        if (
            store.get('insAdminSession').role === RESPONSE_CONSTANT.LEVEL_TWO_ADMIN ||
            store.get('insAdminSession').role === RESPONSE_CONSTANT.BRANCHADMIN
        ) {
            this.props.notificationCount((reponse) => {
                if (reponse) {
                    if (reponse.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                        this.setState({ notificationCount: reponse.response.unread });
                    } else {
                        this.props.showNotification(reponse.message, RESPONSE_CONSTANT.ERROR);
                        return;
                    }
                }
            });
        }
    }

    /**
     * Render page
     */
    render() {
        return (
            <header
                className={`px-8 ${
                    store.get('insAdminSession').role === RESPONSE_CONSTANT.BRANCHADMIN
                        ? 'sm:py-2 py-4'
                        : 'py-4'
                } bg-white flex justify-between xl:justify-end border-bottom`}
            >
                <button
                    className="block xl:hidden"
                    onClick={() => {
                        this.props.onClickMobileNav(true);
                    }}
                >
                    <i className="far fa-align-left text-lg"></i>
                </button>
                <div className="relative show-logout-details">
                    {(store.get('insAdminSession').role === RESPONSE_CONSTANT.LEVEL_TWO_ADMIN ||
                        store.get('insAdminSession').role === RESPONSE_CONSTANT.BRANCHADMIN) && (
                        <Menu>
                            <Menu.Button className="z-0 relative mr-3">
                                <i
                                    className="far fa-bell text-black"
                                    style={{ fontSize: '20px' }}
                                ></i>
                                {this.state.notificationCount > 0 && (
                                    <span
                                        className={`bell-circle-admin ${
                                            store.get('insAdminSession').role ===
                                            RESPONSE_CONSTANT.BRANCHADMIN
                                                ? 'pt-0.5'
                                                : ''
                                        } `}
                                    >
                                        {this.state.notificationCount}
                                    </span>
                                )}
                            </Menu.Button>
                            <Menu.Items className="absolute z-10 bg-white text-black sm:w-auto notify-popup h-auto sm:p-6 p-4 rounded-lg shadow-lg border-black-10 origin-top-right mobile-dropdown right-0">
                                <NotificationPopUp
                                    opened={this.opened}
                                    openModal={this.state.isOpenSwitch}
                                    role={store.get('insAdminSession').role}
                                    history={this.props.history}
                                    clickedNotification={this.clickedNotification}
                                    closeModel={() => {
                                        this.setState({ isOpenSwitch: false });
                                    }}
                                    text="Enable Verification"
                                    notificationUnreadCount={this.props.notificationUnreadCount}
                                    getnotificationCount={() => this.getnotificationCount()}
                                />
                            </Menu.Items>
                        </Menu>
                    )}
                    <Menu>
                        <Menu.Button className="z-0">
                            <div className="flex gap-2 items-center">
                                <span className="h-8 w-8 rounded-full overflow-hidden border-black-10 flex justify-center items-center">
                                    <i
                                        className="fas fa-ellipsis-v text-secondary"
                                        aria-hidden="true"
                                    ></i>
                                </span>
                            </div>
                        </Menu.Button>
                        <Menu.Items className="absolute z-10 right-0 mobile-dropdown origin-top-right rounded-lg border-black-10 bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none transform opacity-100 scale-100 flex flex-col">
                            <Menu.Item>
                                <div className="flex px-4 py-2 gap-4">
                                    <div className="flex flex-col text-black w-64 table-ellipse">
                                        <p className="m-0">
                                            {store.get('insAdminSession').role === 'GRA_ADMIN' && (
                                                <span
                                                    className="table-ellipse"
                                                    title={store.get('insAdminSession').name}
                                                >
                                                    {store.get('insAdminSession').name}
                                                </span>
                                            )}
                                            {store.get('insAdminSession').role ===
                                                RESPONSE_CONSTANT.BRANCHADMIN && (
                                                <span
                                                    className="table-ellipse"
                                                    title={
                                                        store.get('insAdminSession').levelThree.name
                                                    }
                                                >
                                                    {store.get('insAdminSession').levelThree.name}
                                                </span>
                                            )}
                                            {store.get('insAdminSession').role ===
                                                RESPONSE_CONSTANT.LEVEL_TWO_ADMIN && (
                                                <span
                                                    className="table-ellipse"
                                                    title={
                                                        store.get('insAdminSession').levelTwo.name
                                                    }
                                                >
                                                    {store.get('insAdminSession').levelTwo.name}
                                                </span>
                                            )}
                                            {store.get('insAdminSession').role ===
                                                RESPONSE_CONSTANT.LEVEL_ONE_ADMIN && (
                                                <span
                                                    className="table-ellipse"
                                                    title={
                                                        store.get('insAdminSession').levelOne.name
                                                    }
                                                >
                                                    {store.get('insAdminSession').levelOne.name}
                                                </span>
                                            )}
                                        </p>
                                        <p
                                            className="m-0 text-muted table-ellipse"
                                            title={store.get('insAdminSession').email.toLowerCase()}
                                        >
                                            {' '}
                                            {store.get('insAdminSession') &&
                                                store.get('insAdminSession').email.toLowerCase()}
                                        </p>
                                    </div>
                                </div>
                            </Menu.Item>
                            <Menu.Item>
                                <div
                                    className="px-4 py-2 items-center flex gap-2 text-red cursor-pointer"
                                    onClick={() => this.inkoveSignOut()}
                                >
                                    <i className="far fa-sign-out"></i> Logout
                                </div>
                            </Menu.Item>
                        </Menu.Items>
                    </Menu>
                </div>
                <div className="sm:flex hidden gap-3 show-email-details items-end">
                    <div className="text-end" style={{ color: 'lightgrey' }}>
                        {store.get('insAdminSession').role ===
                            RESPONSE_CONSTANT.LEVEL_TWO_ADMIN && (
                            <div
                                className="table-ellipse"
                                style={{ fontSize: '15px' }}
                                title={store.get('insAdminSession').levelOne.name}
                            >
                                {store.get('insAdminSession').levelOne.name}
                            </div>
                        )}
                        {store.get('insAdminSession').role === RESPONSE_CONSTANT.BRANCHADMIN && (
                            <>
                                <div
                                    className="table-ellipse"
                                    style={{ fontSize: '15px' }}
                                    title={store.get('insAdminSession').levelOne.name}
                                >
                                    {store.get('insAdminSession').levelOne.name}
                                </div>
                                <div
                                    className="table-ellipse"
                                    style={{ fontSize: '12px' }}
                                    title={store.get('insAdminSession').levelTwo.name}
                                >
                                    {store.get('insAdminSession').levelTwo.name}
                                </div>
                            </>
                        )}
                    </div>
                    {store.get('insAdminSession').role === RESPONSE_CONSTANT.LEVEL_TWO_ADMIN ? (
                        <span
                            className="xxl:ml-8 xxl:mr-8 lg:ml-4 lg:mr-4 h-6 line-bg hidden sm:block"
                            aria-hidden="true"
                        ></span>
                    ) : store.get('insAdminSession').role === RESPONSE_CONSTANT.BRANCHADMIN ? (
                        <span
                            className="xxl:ml-8 xxl:mr-8 lg:ml-4 lg:mr-4 h-10 line-bg hidden sm:block"
                            aria-hidden="true"
                        ></span>
                    ) : (
                        ''
                    )}
                    {(store.get('insAdminSession').role === RESPONSE_CONSTANT.LEVEL_TWO_ADMIN ||
                        store.get('insAdminSession').role === RESPONSE_CONSTANT.BRANCHADMIN) && (
                        <div className="flex gap-4">
                            <Menu>
                                <Menu.Button className="z-0 relative">
                                    <i
                                        className="far fa-bell text-black"
                                        style={{ fontSize: '17px' }}
                                    ></i>
                                    {this.state.notificationCount > 0 && (
                                        <span
                                            className={`bell-circle-admin ${
                                                store.get('insAdminSession').role ===
                                                RESPONSE_CONSTANT.BRANCHADMIN
                                                    ? 'pt-0.5'
                                                    : ''
                                            } `}
                                        >
                                            {this.state.notificationCount}
                                        </span>
                                    )}
                                </Menu.Button>
                                <Menu.Items className="absolute z-10 bg-white text-black sm:w-auto notify-popup h-auto top-14 sm:p-6 p-4 rounded-lg shadow-lg border-black-10 sm:right-20 right-2 origin-top-right">
                                    <NotificationPopUp
                                        opened={this.opened}
                                        openModal={this.state.isOpenSwitch}
                                        role={store.get('insAdminSession').role}
                                        history={this.props.history}
                                        clickedNotification={this.clickedNotification}
                                        closeModel={() => {
                                            this.setState({ isOpenSwitch: false });
                                        }}
                                        text="Enable Verification"
                                        notificationUnreadCount={this.props.notificationUnreadCount}
                                        getnotificationCount={() => this.getnotificationCount()}
                                    />
                                </Menu.Items>
                            </Menu>
                        </div>
                    )}
                    <div className="relative">
                        <Menu>
                            <Menu.Button className="z-0">
                                <div className="flex gap-2 items-center">
                                    {store.get('insAdminSession').role === 'GRA_ADMIN' && (
                                        <span
                                            className="table-ellipse"
                                            title={store.get('insAdminSession').name}
                                        >
                                            {store.get('insAdminSession').name}
                                        </span>
                                    )}
                                    {store.get('insAdminSession').role ===
                                        RESPONSE_CONSTANT.BRANCHADMIN && (
                                        <span
                                            className="table-ellipse"
                                            title={store.get('insAdminSession').levelThree.name}
                                        >
                                            {store.get('insAdminSession').levelThree.name}
                                        </span>
                                    )}
                                    {store.get('insAdminSession').role ===
                                        RESPONSE_CONSTANT.LEVEL_TWO_ADMIN && (
                                        <span
                                            className="table-ellipse"
                                            title={store.get('insAdminSession').levelTwo.name}
                                        >
                                            {store.get('insAdminSession').levelTwo.name}
                                        </span>
                                    )}
                                    {store.get('insAdminSession').role ===
                                        RESPONSE_CONSTANT.LEVEL_ONE_ADMIN && (
                                        <span
                                            className="table-ellipse"
                                            title={store.get('insAdminSession').levelOne.name}
                                        >
                                            {store.get('insAdminSession').levelOne.name}
                                        </span>
                                    )}
                                    <i
                                        className="far fa-angle-down text-secondary"
                                        aria-hidden="true"
                                    ></i>
                                </div>
                            </Menu.Button>
                            <Menu.Items className="absolute z-10 right-0 mobile-dropdown origin-top-right rounded-lg border-black-10 bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none transform opacity-100 scale-100 flex flex-col">
                                <Menu.Item>
                                    <div className="flex flex-col text-black table-ellipse w-64 px-4 py-2">
                                        <p className="m-0 table-ellipse">
                                            {store.get('insAdminSession').role === 'GRA_ADMIN' && (
                                                <span
                                                    className="table-ellipse"
                                                    title={store.get('insAdminSession').name}
                                                >
                                                    {store.get('insAdminSession').name}
                                                </span>
                                            )}
                                            {store.get('insAdminSession').role ===
                                                RESPONSE_CONSTANT.BRANCHADMIN && (
                                                <span
                                                    className="table-ellipse"
                                                    title={
                                                        store.get('insAdminSession').levelThree.name
                                                    }
                                                >
                                                    {store.get('insAdminSession').levelThree.name}
                                                </span>
                                            )}
                                            {store.get('insAdminSession').role ===
                                                RESPONSE_CONSTANT.LEVEL_TWO_ADMIN && (
                                                <span
                                                    className="table-ellipse"
                                                    title={
                                                        store.get('insAdminSession').levelTwo.name
                                                    }
                                                >
                                                    {store.get('insAdminSession').levelTwo.name}
                                                </span>
                                            )}
                                            {store.get('insAdminSession').role ===
                                                RESPONSE_CONSTANT.LEVEL_ONE_ADMIN && (
                                                <span
                                                    className="table-ellipse"
                                                    title={
                                                        store.get('insAdminSession').levelOne.name
                                                    }
                                                >
                                                    {store.get('insAdminSession').levelOne.name}
                                                </span>
                                            )}
                                        </p>
                                        <p
                                            className="m-0 text-muted table-ellipse"
                                            title={store.get('insAdminSession').email.toLowerCase()}
                                        >
                                            {store.get('insAdminSession') &&
                                                store.get('insAdminSession').email.toLowerCase()}
                                        </p>
                                    </div>
                                </Menu.Item>
                                <Menu.Item>
                                    <div
                                        className="px-4 py-2 items-center flex gap-2 text-red cursor-pointer"
                                        onClick={() => this.inkoveSignOut()}
                                    >
                                        <i className="far fa-sign-out"></i> Logout
                                    </div>
                                </Menu.Item>
                            </Menu.Items>
                        </Menu>
                    </div>
                </div>
            </header>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        notificationUnreadCount: state.AdminNotificationReducer.notificationDetails,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        logOutUser: (callback) => {
            dispatch(logOutUser(callback));
        },
        showNotification: (message, type) => {
            dispatch(showNotification(message, type));
        },
        getSystemFeature: (callback) => {
            dispatch(getSystemFeature(callback));
        },
        notificationCount: (callback) => {
            dispatch(notificationCount(callback));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(SuperAdminHeader);
